<template>
  <div class="layout-main">
    <div class="main-cont-router">
      <MainRouteKeepAlive ref="mainRoute"></MainRouteKeepAlive>
    </div>
  </div>
</template>

<script>
import MainRouteKeepAlive from './elements/route/MainRouteKeepAlive'
export default {
  name: 'LayoutMain',
  components: {MainRouteKeepAlive},
  methods: {
    loadLayoutConfig () {
      this.$store.dispatch('loadConfigFromLocal').then(() => {})
    },
    refreshCurrentTab () {
      let mainRoute = this.$refs.mainRoute
      if (mainRoute) {
        mainRoute.refreshCurrent()
      }
    }
  },
  created () {
    this.loadLayoutConfig()
  }
}
</script>

<style lang="scss">
  .layout-main {
    height: 100%;
    & > .main-cont-router {
      position: relative;
      height: 100%;
    }
  }
</style>
